module.exports = __webpack_public_path__ + "img/ER.aa08f819.svg";